export default "__VITE_ASSET__TMIJss3s__"